var $ = require( "jquery" )

function accept_registration() {
  $('#accept').show('slow');
}

function cancel_accept_registration() {
  $('#accept').hide('slow');
}

$("#accept_registration").click(accept_registration)
$("#cancel_accept_registration").click(cancel_accept_registration)
